import React from 'react';
import styled from '../../styled';
import TabsHeader from './TabsHeader';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, backgroundColor }) => theme.colors[backgroundColor]};
`;
const Body = styled.div `
  padding: 0
    ${({ theme, bodyPadding }) => theme.tabs.content.padding[bodyPadding]};
`;
const TabsContainer = ({ backgroundColor = 'SNOW_100', renderTabs, renderContent, bodyPadding = 'none', }) => {
    return (React.createElement(Container, { backgroundColor: backgroundColor },
        React.createElement(TabsHeader, { backgroundColor: backgroundColor, renderTabs: renderTabs }),
        React.createElement(Body, { bodyPadding: bodyPadding }, renderContent())));
};
export default TabsContainer;
//# sourceMappingURL=TabsContainer.js.map